import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=0d487f4d&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d487f4d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d487f4d')) {
      api.createRecord('0d487f4d', component.options)
    } else {
      api.reload('0d487f4d', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=0d487f4d&scoped=true&", function () {
      api.rerender('0d487f4d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2O0CCoyP4zXFA/JS/comp/Accordion.vue"
export default component.exports